import React from "react";
import { brl } from "../../../lib/api";
import { InfoSheet } from "./InfoSheet";
import { T } from "./theme";

const Disclaimer = () => (
  <p className="rounded-2xl p-3 text-[13px]" style={{ background: T.goldSoft, color: "#6B4E12" }} data-testid="sheet-disclaimer">
    A pontuação é uma avaliação interna e não garante crédito, limite, aprovação ou benefícios.
  </p>
);

export const ExplainSheet = ({ open, onClose, s }) => (
  <InfoSheet open={open} onClose={onClose} title="Entenda seu score" description="Como funciona o CRIS CREDIT" testid="explain-sheet">
    <p>O CRIS CREDIT é a avaliação de 0 a 1000 do seu comportamento de pagamento com a Cris Lingerie e a Eletros. Ele é atualizado periodicamente a partir do seu histórico real.</p>
    <div>
      <b className="block" style={{ color: T.deep }}>O que influencia a pontuação</b>
      <ul className="mt-2 space-y-1.5" data-testid="explain-weights">
        {(s.weights || []).map((w) => (
          <li key={w.key} className="flex items-center gap-3">
            <span className="min-w-0 flex-1 text-[14px]">{w.label}</span>
            <span className="h-2 w-24 overflow-hidden rounded-full bg-[#EEE8F5]"><span className="block h-full rounded-full" style={{ width: `${w.pct}%`, background: T.violet }} /></span>
            <span className="w-10 text-right text-[13px] font-bold tabular-nums">{w.pct}%</span>
          </li>
        ))}
      </ul>
    </div>
    <div>
      <b className="block" style={{ color: T.deep }}>Como fortalecer seu histórico</b>
      <ul className="mt-1 list-disc space-y-1 pl-5 text-[14px]">
        <li>Pague suas parcelas até o vencimento.</li>
        <li>Regularize parcelas em atraso assim que possível.</li>
        <li>Use o limite com equilíbrio.</li>
      </ul>
    </div>
    <p className="text-[13px]" style={{ color: T.muted }}>Pagamentos confirmados aparecem na próxima atualização da avaliação.</p>
    <Disclaimer />
  </InfoSheet>
);

export const LimitSheet = ({ open, onClose, door }) => (
  <InfoSheet open={open} onClose={onClose} title="Entenda seu limite" testid="limit-sheet">
    {door?.limit ? (
      <div className="grid grid-cols-2 gap-2" data-testid="limit-values">
        <div className="rounded-2xl p-3" style={{ background: T.lavender }}><div className="text-[12px]" style={{ color: T.muted }}>Limite atual</div><b className="text-[18px]">{brl(door.limit.current)}</b></div>
        <div className="rounded-2xl p-3" style={{ background: T.lavender }}><div className="text-[12px]" style={{ color: T.muted }}>Em uso</div><b className="text-[18px]">{door.limit.utilization_pct}%</b></div>
      </div>
    ) : <p data-testid="limit-none">Ainda não há limite registrado para você.</p>}
    <p>Seu limite é definido pela política de crédito vigente e pela análise da sua revendedora. Manter os pagamentos em dia e usar o limite com equilíbrio contribui para análises futuras.</p>
    <p className="text-[13px]" style={{ color: T.muted }}>Não há aumento automático de limite por esta tela.</p>
    <Disclaimer />
  </InfoSheet>
);

export const BenefitsSheet = ({ open, onClose }) => (
  <InfoSheet open={open} onClose={onClose} title="Benefícios exclusivos" testid="benefits-sheet">
    <p data-testid="benefits-none">No momento não há campanhas de benefícios ativas.</p>
    <p>Quando houver campanhas para clientes elegíveis, elas aparecerão aqui com as regras de participação.</p>
    <Disclaimer />
  </InfoSheet>
);
